import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import useEntityId from '@/components/entities/components/details/hooks/use-entity-id';
import useEntityTimeline from '@/components/entities/components/details/hooks/use-entity-timeline';
import Timeline from '@/components/timeline';
import WatchlistCheckEventBody from '../../../../watchlist-check-event-body';
import WatchlistCheckEventIcon from '../../../../watchlist-check-event-icon';
const WatchlistCheckEventsDrawerContent = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "auditTrail.timeline.watchlistCheckEvent"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  const id = useEntityId();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      kinds: "watchlist_check"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data,
    hasNextPage,
    fetchNextPage
  } = useEntityTimeline(id, t1, true);
  let t2;
  if ($[2] !== data || $[3] !== t) {
    t2 = data?.flatMap(event => {
      const {
        event: t3,
        timestamp
      } = event;
      const {
        data: eventData,
        kind
      } = t3;
      if (kind !== "watchlist_check") {
        return [];
      }
      return {
        headerComponent: <div className="flex justify-between items-center w-full"><div className="text-label-2 text-primary" data-testid="watchlist-check-event-header">{t(_temp)}</div><div className="flex gap-1"><div className="text-body-2 text-tertiary">{`${new Date(timestamp).toLocaleString("en-us", {
                month: "2-digit",
                day: "2-digit",
                year: "2-digit"
              })},`}</div><div className="text-body-2 text-tertiary">{new Date(timestamp).toLocaleString("en-us", {
                hour: "numeric",
                minute: "numeric"
              })}</div></div></div>,
        bodyComponent: <WatchlistCheckEventBody data={eventData} lineHeight="default" showIcons={true} />,
        iconComponent: <WatchlistCheckEventIcon />
      };
    });
    $[2] = data;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const timelineItems = t2;
  let t3;
  if ($[5] !== timelineItems) {
    t3 = timelineItems || [];
    $[5] = timelineItems;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== fetchNextPage || $[8] !== hasNextPage) {
    t4 = {
      hasNextPage,
      fetchNextPage
    };
    $[7] = fetchNextPage;
    $[8] = hasNextPage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <Timeline items={t3} pagination={t4} />;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default WatchlistCheckEventsDrawerContent;
function _temp($) {
  return $.drawerTitle;
}